import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ComissaoListarRoutingModule } from './comissao-listar-routing.module';
import { ComissaoListarComponent } from './comissao-listar.component';
import { FormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { MessagesModule } from 'primeng/messages';
import { DropdownModule } from 'primeng/dropdown';
import { CalendarModule } from 'primeng/calendar';
import { TooltipModule } from 'primeng/tooltip';


@NgModule({
  declarations: [
    ComissaoListarComponent
  ],
  imports: [
    CommonModule,
    ComissaoListarRoutingModule,
    FormsModule,
    TableModule,
    InputTextModule,
    ButtonModule,
    MessagesModule,
    DropdownModule,
    CalendarModule,
    TooltipModule
  ]
})
export class ComissaoListarModule { }
